export default __webpack_public_path__ + "static/media/fb.6524b0bb.svg";